module.exports = __webpack_public_path__ + "img/76.857701d2.jpg";